'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var styled = _interopDefault(require('styled-components'));
var functions = require('@keytrade/functions');
var React = _interopDefault(require('react'));
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
var focusVisible = createCommonjsModule(function (module, exports) {
  (function (global, factory) {
    factory();
  })(commonjsGlobal, function () {
    /**
     * Applies the :focus-visible polyfill at the given scope.
     * A scope in this case is either the top-level Document or a Shadow Root.
     *
     * @param {(Document|ShadowRoot)} scope
     * @see https://github.com/WICG/focus-visible
     */

    function applyFocusVisiblePolyfill(scope) {
      var hadKeyboardEvent = true;
      var hadFocusVisibleRecently = false;
      var hadFocusVisibleRecentlyTimeout = null;
      var inputTypesAllowlist = {
        text: true,
        search: true,
        url: true,
        tel: true,
        email: true,
        password: true,
        number: true,
        date: true,
        month: true,
        week: true,
        time: true,
        datetime: true,
        'datetime-local': true
      };
      /**
       * Helper function for legacy browsers and iframes which sometimes focus
       * elements like document, body, and non-interactive SVG.
       * @param {Element} el
       */

      function isValidFocusTarget(el) {
        if (el && el !== document && el.nodeName !== 'HTML' && el.nodeName !== 'BODY' && 'classList' in el && 'contains' in el.classList) {
          return true;
        }
        return false;
      }
      /**
       * Computes whether the given element should automatically trigger the
       * `focus-visible` class being added, i.e. whether it should always match
       * `:focus-visible` when focused.
       * @param {Element} el
       * @return {boolean}
       */

      function focusTriggersKeyboardModality(el) {
        var type = el.type;
        var tagName = el.tagName;
        if (tagName === 'INPUT' && inputTypesAllowlist[type] && !el.readOnly) {
          return true;
        }
        if (tagName === 'TEXTAREA' && !el.readOnly) {
          return true;
        }
        if (el.isContentEditable) {
          return true;
        }
        return false;
      }
      /**
       * Add the `focus-visible` class to the given element if it was not added by
       * the author.
       * @param {Element} el
       */

      function addFocusVisibleClass(el) {
        if (el.classList.contains('focus-visible')) {
          return;
        }
        el.classList.add('focus-visible');
        el.setAttribute('data-focus-visible-added', '');
      }
      /**
       * Remove the `focus-visible` class from the given element if it was not
       * originally added by the author.
       * @param {Element} el
       */

      function removeFocusVisibleClass(el) {
        if (!el.hasAttribute('data-focus-visible-added')) {
          return;
        }
        el.classList.remove('focus-visible');
        el.removeAttribute('data-focus-visible-added');
      }
      /**
       * If the most recent user interaction was via the keyboard;
       * and the key press did not include a meta, alt/option, or control key;
       * then the modality is keyboard. Otherwise, the modality is not keyboard.
       * Apply `focus-visible` to any current active element and keep track
       * of our keyboard modality state with `hadKeyboardEvent`.
       * @param {KeyboardEvent} e
       */

      function onKeyDown(e) {
        if (e.metaKey || e.altKey || e.ctrlKey) {
          return;
        }
        if (isValidFocusTarget(scope.activeElement)) {
          addFocusVisibleClass(scope.activeElement);
        }
        hadKeyboardEvent = true;
      }
      /**
       * If at any point a user clicks with a pointing device, ensure that we change
       * the modality away from keyboard.
       * This avoids the situation where a user presses a key on an already focused
       * element, and then clicks on a different element, focusing it with a
       * pointing device, while we still think we're in keyboard modality.
       * @param {Event} e
       */

      function onPointerDown(e) {
        hadKeyboardEvent = false;
      }
      /**
       * On `focus`, add the `focus-visible` class to the target if:
       * - the target received focus as a result of keyboard navigation, or
       * - the event target is an element that will likely require interaction
       *   via the keyboard (e.g. a text box)
       * @param {Event} e
       */

      function onFocus(e) {
        // Prevent IE from focusing the document or HTML element.
        if (!isValidFocusTarget(e.target)) {
          return;
        }
        if (hadKeyboardEvent || focusTriggersKeyboardModality(e.target)) {
          addFocusVisibleClass(e.target);
        }
      }
      /**
       * On `blur`, remove the `focus-visible` class from the target.
       * @param {Event} e
       */

      function onBlur(e) {
        if (!isValidFocusTarget(e.target)) {
          return;
        }
        if (e.target.classList.contains('focus-visible') || e.target.hasAttribute('data-focus-visible-added')) {
          // To detect a tab/window switch, we look for a blur event followed
          // rapidly by a visibility change.
          // If we don't see a visibility change within 100ms, it's probably a
          // regular focus change.
          hadFocusVisibleRecently = true;
          window.clearTimeout(hadFocusVisibleRecentlyTimeout);
          hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
            hadFocusVisibleRecently = false;
          }, 100);
          removeFocusVisibleClass(e.target);
        }
      }
      /**
       * If the user changes tabs, keep track of whether or not the previously
       * focused element had .focus-visible.
       * @param {Event} e
       */

      function onVisibilityChange(e) {
        if (document.visibilityState === 'hidden') {
          // If the tab becomes active again, the browser will handle calling focus
          // on the element (Safari actually calls it twice).
          // If this tab change caused a blur on an element with focus-visible,
          // re-apply the class when the user switches back to the tab.
          if (hadFocusVisibleRecently) {
            hadKeyboardEvent = true;
          }
          addInitialPointerMoveListeners();
        }
      }
      /**
       * Add a group of listeners to detect usage of any pointing devices.
       * These listeners will be added when the polyfill first loads, and anytime
       * the window is blurred, so that they are active when the window regains
       * focus.
       */

      function addInitialPointerMoveListeners() {
        document.addEventListener('mousemove', onInitialPointerMove);
        document.addEventListener('mousedown', onInitialPointerMove);
        document.addEventListener('mouseup', onInitialPointerMove);
        document.addEventListener('pointermove', onInitialPointerMove);
        document.addEventListener('pointerdown', onInitialPointerMove);
        document.addEventListener('pointerup', onInitialPointerMove);
        document.addEventListener('touchmove', onInitialPointerMove);
        document.addEventListener('touchstart', onInitialPointerMove);
        document.addEventListener('touchend', onInitialPointerMove);
      }
      function removeInitialPointerMoveListeners() {
        document.removeEventListener('mousemove', onInitialPointerMove);
        document.removeEventListener('mousedown', onInitialPointerMove);
        document.removeEventListener('mouseup', onInitialPointerMove);
        document.removeEventListener('pointermove', onInitialPointerMove);
        document.removeEventListener('pointerdown', onInitialPointerMove);
        document.removeEventListener('pointerup', onInitialPointerMove);
        document.removeEventListener('touchmove', onInitialPointerMove);
        document.removeEventListener('touchstart', onInitialPointerMove);
        document.removeEventListener('touchend', onInitialPointerMove);
      }
      /**
       * When the polfyill first loads, assume the user is in keyboard modality.
       * If any event is received from a pointing device (e.g. mouse, pointer,
       * touch), turn off keyboard modality.
       * This accounts for situations where focus enters the page from the URL bar.
       * @param {Event} e
       */

      function onInitialPointerMove(e) {
        // Work around a Safari quirk that fires a mousemove on <html> whenever the
        // window blurs, even if you're tabbing out of the page. ¯\_(ツ)_/¯
        if (e.target.nodeName && e.target.nodeName.toLowerCase() === 'html') {
          return;
        }
        hadKeyboardEvent = false;
        removeInitialPointerMoveListeners();
      } // For some kinds of state, we are interested in changes at the global scope
      // only. For example, global pointer input, global key presses and global
      // visibility change should affect the state at every scope:

      document.addEventListener('keydown', onKeyDown, true);
      document.addEventListener('mousedown', onPointerDown, true);
      document.addEventListener('pointerdown', onPointerDown, true);
      document.addEventListener('touchstart', onPointerDown, true);
      document.addEventListener('visibilitychange', onVisibilityChange, true);
      addInitialPointerMoveListeners(); // For focus and blur, we specifically care about state changes in the local
      // scope. This is because focus / blur events that originate from within a
      // shadow root are not re-dispatched from the host element if it was already
      // the active element in its own scope:

      scope.addEventListener('focus', onFocus, true);
      scope.addEventListener('blur', onBlur, true); // We detect that a node is a ShadowRoot by ensuring that it is a
      // DocumentFragment and also has a host property. This check covers native
      // implementation and polyfill implementation transparently. If we only cared
      // about the native implementation, we could just check if the scope was
      // an instance of a ShadowRoot.

      if (scope.nodeType === Node.DOCUMENT_FRAGMENT_NODE && scope.host) {
        // Since a ShadowRoot is a special kind of DocumentFragment, it does not
        // have a root element to add a class to. So, we add this attribute to the
        // host element instead:
        scope.host.setAttribute('data-js-focus-visible', '');
      } else if (scope.nodeType === Node.DOCUMENT_NODE) {
        document.documentElement.classList.add('js-focus-visible');
        document.documentElement.setAttribute('data-js-focus-visible', '');
      }
    } // It is important to wrap all references to global window and document in
    // these checks to support server-side rendering use cases
    // @see https://github.com/WICG/focus-visible/issues/199

    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      // Make the polyfill helper globally available. This can be used as a signal
      // to interested libraries that wish to coordinate with the polyfill for e.g.,
      // applying the polyfill to a shadow root:
      window.applyFocusVisiblePolyfill = applyFocusVisiblePolyfill; // Notify interested libraries of the polyfill's presence, in case the
      // polyfill was loaded lazily:

      var event;
      try {
        event = new CustomEvent('focus-visible-polyfill-ready');
      } catch (error) {
        // IE11 does not support using CustomEvent as a constructor directly:
        event = document.createEvent('CustomEvent');
        event.initCustomEvent('focus-visible-polyfill-ready', false, false, {});
      }
      window.dispatchEvent(event);
    }
    if (typeof document !== 'undefined') {
      // Apply the polyfill to the global document, so that no JavaScript
      // coordination is required to use the polyfill in the top-level document:
      applyFocusVisiblePolyfill(document);
    }
  });
});
var colors = functions.config.colors.list;
var getFont = functions.config.fonts.getFont;
var AccordionWrapper = styled.div.withConfig({
  displayName: "Accordionstyled__AccordionWrapper",
  componentId: "arvhyg-0"
})(["margin:", ";> div:nth-child(n+2){margin-top:8px;}"], function (props) {
  return props.margin;
});
var AccordionHeaderWrapper = styled.div.withConfig({
  displayName: "Accordionstyled__AccordionHeaderWrapper",
  componentId: "arvhyg-1"
})(["position:relative;width:100%;display:flex;svg{position:absolute;pointer-events:none;top:12px;z-index:2;transition:0.2s ease-out transform;", " right:3px;@media ", "{top:16px;right:16px;}}"], function (props) {
  return props.isActive && "transform: rotate(180deg);";
}, functions.config.breakpoints.device.tablet);
var AccordionItem = styled.div.withConfig({
  displayName: "Accordionstyled__AccordionItem",
  componentId: "arvhyg-2"
})(["background:", ";border-radius:10px;border:1px solid ", ";", ";"], colors.White, colors.GreyWhite, function (props) {
  return props.isActive && "\n    box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.05), 0px 2px 5px 0px rgba(0, 0, 0, 0.05);\n  ";
});
var AccordionHeaderButton = styled.button.withConfig({
  displayName: "Accordionstyled__AccordionHeaderButton",
  componentId: "arvhyg-3"
})(["background-color:", ";border:none;color:", ";cursor:pointer;flex:1 1 auto;font-family:", ";text-align:left;border-radius:", ";transition:background-color ease 0.2s;font-size:1.4rem;padding:1.2rem 3.8rem 1.2rem .8rem;@media ", "{font-size:1.6rem;padding:1.6rem 4.6rem 1.6rem 1.6rem;}&:focus{background-color:", ";outline:none;}&:focus:not(.focus-visible),&:not([data-focus-visible-added]):focus{background-color:", ";outline:none;}&.focus-visible:focus,&[data-focus-visible-added]:focus,&.focus-visible,&.focus-visible[data-focus-visible-added]{background-color:", ";outline:none;}"], colors.Transparent, colors.BlueDark, function (props) {
  return getFont(props.theme, 'bold');
}, function (props) {
  return props.isActive ? '10px 10px 0 0' : '10px';
}, functions.config.breakpoints.device.tablet, colors.Transparent, colors.Transparent, colors.GreyBackground);
var AccordionItemContentWrapper = styled.div.withConfig({
  displayName: "Accordionstyled__AccordionItemContentWrapper",
  componentId: "arvhyg-4"
})(["display:block;color:", ";transition-property:height,padding;transition-duration:1s,0.05s;transition-timing-function:ease,ease;height:", ";overflow:hidden;text-align:left;font-size:1.2rem;padding:", ";@media ", "{font-size:1.4rem;padding:", ";}"], colors.BlueDark, function (props) {
  return props.isActive ? 'auto' : '0';
}, function (props) {
  return props.isActive ? '.8rem .8rem 1.2rem' : '0 .8rem';
}, functions.config.breakpoints.device.tablet, function (props) {
  return props.isActive ? '.8rem 1.6rem 1.2rem' : '0 1.6rem';
});
var colors$1 = functions.config.colors.list;
var Arrow = function Arrow() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "2.4rem",
    height: "2.4rem",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: colors$1.BlueSky,
    fillRule: "evenodd",
    d: "M11.296 14.998L5.45 9.108a.597.597 0 0 1 0-.85l.358-.355a.609.609 0 0 1 .856 0l5.06 5.115 5.058-5.11a.609.609 0 0 1 .857 0l.357.355a.597.597 0 0 1 0 .85l-5.845 5.89a.613.613 0 0 1-.856-.005z"
  }));
};
var colors$2 = functions.config.colors.list;
var Accordion = /*#__PURE__*/function (_React$Component) {
  _inherits(Accordion, _React$Component);
  var _super = _createSuper(Accordion);
  function Accordion(props) {
    var _this;
    _classCallCheck(this, Accordion);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "areEqualArrays", function (array1, array2) {
      if (array1.length !== array2.length) return false;
      return array1.every(function (value, index) {
        return value === array2[index];
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleAccordionToggle", function (value, byClick, multipleOpen) {
      var newStateArray = _toConsumableArray(_this.state.isOpenIndexes);
      if (multipleOpen) {
        if (byClick) {
          if (newStateArray.indexOf(value) > -1) {
            newStateArray.splice(newStateArray.indexOf(value), 1);
          } else {
            newStateArray.push(value);
          }
          newStateArray = newStateArray.sort();
          _this.setState({
            isOpenIndexes: newStateArray
          });
        } else {
          _this.setState({
            isOpenIndexes: _this.props.isOpenIndexes.sort()
          });
        }
      } else {
        if (isNaN(value)) return null;
        if (_this.state.isOpenIndexes.indexOf(value) > -1) {
          var arrayWithoutClickedIndex = _toConsumableArray(_this.state.isOpenIndexes);
          /** remove it */

          arrayWithoutClickedIndex.splice(_this.state.isOpenIndexes.indexOf(value), 1);
          _this.setState({
            isOpenIndexes: arrayWithoutClickedIndex
          });
        } else {
          var newArray = [];
          if (byClick) {
            newArray.push(value);
          } else {
            newArray = _toConsumableArray(value);
          }
          _this.setState({
            isOpenIndexes: newArray
          });
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onClickAccordion", function (index) {
      var byClick = true;
      _this.handleAccordionToggle(index, byClick, _this.props.multipleOpen);
    });
    _this.state = {
      isOpenIndexes: []
    };
    return _this;
  }
  _createClass(Accordion, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpenIndexes && this.props.isOpenIndexes.length > 0) {
        this.handleAccordionToggle(this.props.isOpenIndexes, false, this.props.multipleOpen);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.isOpenIndexes && this.props.isOpenIndexes.length > 0 && prevProps.isOpenIndexes !== this.props.isOpenIndexes) {
        this.handleAccordionToggle(this.props.isOpenIndexes, false, this.props.multipleOpen);
      }
    }
    /**
     * Set a new activeIndex in the state based on the clicked tab index.
     */
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var isOpenIndexes = this.state.isOpenIndexes;
      var _this$props = this.props,
        data = _this$props.data,
        multipleOpen = _this$props.multipleOpen;
      if (!data || data.length === 0) {
        return null;
      }
      var AccordionContents = data.map(function (entry, i) {
        var isActive = isOpenIndexes.indexOf(i) > -1;
        var itemHeight = AccordionItem.offsetHeight;
        return /*#__PURE__*/React.createElement(AccordionItem, {
          multipleOpen: multipleOpen,
          key: "Accordion_" + i,
          "aria-expanded": isActive,
          isActive: isActive
        }, /*#__PURE__*/React.createElement(AccordionHeaderWrapper, {
          isActive: isActive
        }, /*#__PURE__*/React.createElement(AccordionHeaderButton, {
          onClick: function onClick() {
            return _this2.onClickAccordion(i);
          },
          isActive: isActive
        }, entry.header), /*#__PURE__*/React.createElement(Arrow, {
          color: isActive && colors$2.BlueSky
        })), /*#__PURE__*/React.createElement(AccordionItemContentWrapper, {
          "aria-hidden": !isActive,
          isActive: isActive,
          itemHeight: itemHeight
        }, entry.content));
      });
      return /*#__PURE__*/React.createElement(AccordionWrapper, {
        margin: this.props.margin
      }, data.length > 0 && AccordionContents);
    }
  }]);
  return Accordion;
}(React.Component);
exports.Accordion = Accordion;